import React from "react";
import Alert from "@reach/alert";
import styles from "./ErrorAlert.module.css";

const AlertComponent = ({ message }: { message: string }) => {
  return (
    <div className={styles.container}>
      <Alert className={styles.alert}>
        <span>{message}</span>
      </Alert>
    </div>
  );
};
const ErrorAlert = ({ message }: { message: string }) => {
  return <AlertComponent message={message} />;
};

export default ErrorAlert;
